export default "__VITE_ASSET__6c43251a__"